import React from "react";

import Svg, { Path, Defs, LinearGradient, Stop } from "react-native-svg";
import { uniqueId } from "lodash";
import { TouchableOpacity } from "react-native";

export default function RepeatIcon(props) {
  const filterId = "paint0_linear" + uniqueId();
  const filterUrl = "url(#" + filterId + ")";
  const width = props.width || 24;
  const height = props.height || 24;

  return (
    <TouchableOpacity {...props}>
      <Svg
        width={width}
        height={height}
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29.4634 19.6781C28.5819 13.1191 24.6096 8.44152 18.9895 7.90297C14.3743 7.46072 9.42775 9.90344 5.14714 15.0624C5.14793 14.523 5.15164 13.9909 5.15698 13.4888C5.16601 12.6406 5.17956 11.8895 5.19085 11.3506C5.1965 11.0812 5.20157 10.8652 5.20522 10.717L5.20951 10.5474L5.21066 10.5041L5.21095 10.4935L5.21102 10.491L5.21103 10.4904L5.21104 10.4904L5.21104 10.4903C5.24378 9.30501 4.30944 8.31755 3.1241 8.28478C1.93875 8.25201 0.951268 9.18637 0.918502 10.3717L3.06477 10.431C0.918502 10.3717 0.9185 10.3718 0.918498 10.3719L0.91849 10.3721L0.918465 10.3731L0.918376 10.3763L0.918046 10.3885L0.916815 10.4349L0.912344 10.6113C0.908579 10.7642 0.903385 10.9855 0.897622 11.2606C0.8861 11.8105 0.872274 12.5768 0.863053 13.4431C0.844749 15.1626 0.843958 17.3229 0.919982 18.9642L0.92057 18.9768L0.921308 18.9895C0.950861 19.4974 1.08038 19.9944 1.30244 20.4521C1.52449 20.9097 1.83472 21.3191 2.21532 21.6566C2.59592 21.9941 3.03941 22.2531 3.52035 22.4189C3.98885 22.5803 4.48391 22.6501 4.97855 22.6246L13.2315 22.3678C14.4167 22.3309 15.3476 21.3402 15.3107 20.155C15.2738 18.9697 14.2831 18.0388 13.0979 18.0757L8.10173 18.2312C11.8993 13.439 15.7718 11.9085 18.5799 12.1776C21.6534 12.4721 24.5088 15.0517 25.2075 20.2501C25.3655 21.4253 26.4462 22.25 27.6215 22.0921C28.7967 21.9341 29.6214 20.8533 29.4634 19.6781Z"
          fill={filterUrl}
        />
        <Defs>
          <LinearGradient
            id={filterId}
            x1="0.852782"
            y1="11.0569"
            x2="5.131"
            y2="27.9929"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#05858A" />
            <Stop offset="1" stopColor="#2AE8CB" />
          </LinearGradient>
        </Defs>
      </Svg>
    </TouchableOpacity>
  );
}
